<ng-container *ngIf="routeInfo">
  <a
    *ngIf="routeInfo.external"
    class="anchor"
    [attr.href]="routeInfo.route"
    target="_blank"
  >
    <ng-template *ngTemplateOutlet="item"></ng-template>
  </a>
  <a
    *ngIf="!routeInfo.external"
    class="anchor"
    [routerLink]="routeInfo.route"
    [queryParams]="routeInfo.navigationExtras?.queryParams"
    [queryParamsHandling]="routeInfo.navigationExtras?.queryParamsHandling"
    [replaceUrl]="routeInfo.navigationExtras?.replaceUrl"
    [skipLocationChange]="routeInfo.navigationExtras?.skipLocationChange"
    [attr.target]="routeInfo.external && '_blank'"
  >
    <ng-template *ngTemplateOutlet="item"></ng-template>
  </a>
</ng-container>

<div *ngIf="!routeInfo" class="anchor">
  <ng-template *ngTemplateOutlet="item"></ng-template>
</div>

<ng-template #item>
  <div class="new-indicator" [class.on]="isNew"></div>
  <div class="header-description">
    <div class="header" [class.is-read]="notification.isRead()">
      {{ header }}
    </div>
    <div>{{ description }}</div>
  </div>
  <i2g-icon
    class="close"
    name="close-navigation"
    size="medium"
    (click)="onDismissClick($event)"
  ></i2g-icon>
</ng-template>
